<template>
  <div
    v-if="savedAudioRecordLength"
    @click="goTo"
    class="cursor-pointer height-40 padding-y-8 padding-x-16 margin-bottom-16 background-complementary-50 border-radius-8"
    :class="`${wrapperClass} ${minimized ? 'flex-center' : 'flex-between'}`"
  >
    <div class="flex-start">
      <span class="color-complementary-200 position-relative">
        <mdicon name="volume-high" size="24" />
        <span
          v-if="minimized"
          class="chips chips--error chips--pill padding-bottom-0 position-absolute top--12 right--12"
        >
          {{ savedAudioRecordLength }}
        </span>
      </span>
      <span
        v-if="!minimized"
        class="color-complementary-200 font-size-12 margin-right-4"
      >
        {{ $lang.recordedVoice }}
      </span>
    </div>
    <div class="flex-start">
      <span
        v-if="!minimized"
        class="chips chips--error chips--pill padding-bottom-0"
      >
        {{ savedAudioRecordLength }}
      </span>
    </div>
  </div>
</template>
<script>
import { openDB } from "idb";
import { computed, onMounted, ref, watch } from "vue";
import {
  generateStoreGetters,
  goToRoute,
  storeDispatcher,
} from "@/shared/utils";

export default {
  props: {
    wrapperClass: {
      type: String,
      default: "",
    },
    minimized: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    let dbPromise;

    async function get(key) {
      return (await dbPromise).get("keyval", key);
    }

    const personCode = ref(null);

    const currentUserInfo = computed(() => generateStoreGetters(["userInfo"]));

    const savedAudioRecordLength = computed(() =>
      generateStoreGetters(["savedAudioRecordLength"])
    );

    watch(currentUserInfo, async (value) => {
      personCode.value = value.person.code;
      const savedRecords = await get(personCode.value);
      savedRecords &&
        storeDispatcher("savedAudioRecordLength", savedRecords.length);
    });

    onMounted(() => {
      dbPromise = openDB("keyval-store", 1, {
        upgrade(db) {
          db.createObjectStore("keyval");
        },
      });
    });

    const goTo = () => goToRoute("recorded-voice", {}, {}, false);

    return {
      goTo,
      savedAudioRecordLength,
    };
  },
};
</script>
